import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 12h-14","key":"svg-0"}],["path",{"d":"M6 9l-3 3l3 3","key":"svg-1"}],["path",{"d":"M21 14h-4v-4h4l0 4","key":"svg-2"}]]

/**
 * IconArrowLeftSquare
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctbGVmdC1zcXVhcmUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE3IDEyaC0xNCIgLz4KICA8cGF0aCBkPSJNNiA5bC0zIDNsMyAzIiAvPgogIDxwYXRoIGQ9Ik0yMSAxNGgtNHYtNGg0bDAgNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-left-square
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowLeftSquare = createReactComponent('outline', 'arrow-left-square', 'ArrowLeftSquare', __iconNode);

export default IconArrowLeftSquare;